_ = require 'underscore'
makeErrorEnum = require 'lib/make-error-enum'
IFrameIO = require 'network/iframe-io'
pluginValidators = require 'lib/plugins/plugin-validators'
Promise = require 'bluebird'
Visibility = require 'visibilityjs'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

PluginIOError = makeErrorEnum 'Plugin', [
  'NotHandled'
  'Timeout'
]

module.exports = class PluginIO
  @Error: PluginIOError

  constructor: (plugin, @handlers) ->
    @id = plugin.id
    @capabilities = plugin.get('capabilities')
    @iframeConnectorUrl = plugin.get('iframeConnectorUrl')
    @icon = plugin.get('icon')
    @listing = plugin.get('listing')
    @name = plugin.get('name')
    @moderatedState = plugin.get('moderatedState')

  getName: -> @listing?.name || @name
  getDescription: -> @listing?.description || ''
  getOverview: -> @listing?.overview || ''
  getIconUrl: ->
    iconUrl = @icon?.url
    if pluginValidators.isValidUrlForImage(iconUrl)
      iconUrl
    else
      null

  _getIo: ->
    if @moderatedState == 'moderated'
      throw new Error("Power-Up '#{@getName()}' (id: #{@id}) is moderated")

    @_io ?= new IFrameIO(@iframeConnectorUrl, @handlers)

  request: (command, options, timeout) ->
    if @moderatedState == 'moderated'
      throw new Error("Power-Up '#{@getName()}' (id: #{@id}) is moderated")

    new Promise (resolve) ->
      # we only want to make a request to a Power-Up when the board is in the foreground tab
      # otherwise our communication with it is slowed so drastically by the browser that
      # we are highly prone to timing out. Also updating the information you aren't looking
      # at isn't terribly useful, so we'll just wait for you to be looking.
      Visibility.onVisible resolve
    .then =>
      @_getIo()
      .request(command, options, timeout)
      .catch IFrameIO.Error.NotHandled, ->
        throw PluginIOError.NotHandled()
      .catch IFrameIO.Error.Timeout, (err) ->
        throw PluginIOError.Timeout(err.message)

  supports: (command) ->
    if @moderatedState == 'moderated'
      console?.warn("Warning: Power-Up '#{@getName()}' (id: #{@id}) is moderated.
        Capability '#{command}' was denied."
      )
      return false

    # short term hack to abruptly cut over to native custom fields
    # this should be removed once custom fields v2 is enabled for everyone
    if @id == CUSTOM_FIELDS_ID
      return command == 'callback' || command == 'show-settings'
    _.isArray(@capabilities)? && command in @capabilities

  drop: ->
    @_getIo().then (io) ->
      io?.drop()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-io.coffee